import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { MdArrowBack } from 'react-icons/md';

import { Link } from 'react-router-dom';

import { useForm } from 'react-hook-form';

import { Helmet } from 'react-helmet';

import Swal from 'sweetalert2';

import { toast } from 'react-toastify';

import history from '~/services/history';
import api from '~/services/api';

import { BoxAuth, PageTitle, Left, BoxLabel, Label } from './style';

import { Breadcumbs } from '~/components/Breadcumbs';

export default function Forgot() {
  const { register, handleSubmit, errors } = useForm();

  const loading = useSelector(state => state.auth.loading);

  const [authError, setAuthError] = useState(false);
  const [cpfError, setCpfError] = useState(false);
  const [emailError, setEmailError] = useState(false);

  useEffect(() => {
    if (authError) {
      setTimeout(() => {
        setAuthError(false);
      }, 5000);
    }
  }, [authError]);

  useEffect(() => {
    if (cpfError) {
      setTimeout(() => {
        setCpfError(false);
      }, 5000);
    }
  }, [cpfError]);

  useEffect(() => {
    if (emailError) {
      setTimeout(() => {
        setEmailError(false);
      }, 5000);
    }
  }, [emailError]);

  const onSubmit = async ({ cpf, email }) => {
    if (!cpf && !email) {
      toast.error('Todos os campos são de preenchimento obrigatório', {
        autoClose: false,
      });
      setAuthError(true);
      return;
    }
    if (!cpf) {
      toast.error('O CPF é obrigatório.', { autoClose: false });
      setCpfError(true);
      return;
    }

    if (!email) {
      toast.error('O e-mail é obrigatório.', { autoClose: false });
      setEmailError(true);
      return;
    }

    try {
      await api
        .post('/autenticacao/recuperar-senha', {
          cpf,
          email,
        })
        .then(res => {
          if (res.status === 200) {
            Swal.fire({
              title: 'Pedido enviado com sucesso',
              text: 'Siga as instruções enviadas no e-mail para concluir.',
              icon: 'success',
              confirmButtonColor: '#74a50a',
            }).then(() => {
              history.push('/');
            });
          }
        });
    } catch (error) {
      const defaultError =
        'Não foi possível concluir sua solicitação, verifique seu dados e tente novamente.';
      const cause = error?.response?.data?.cause;

      if (cause === 'inactive_user') {
        Swal.fire({
          title: 'Atenção',
          text: `${error?.response?.data?.error || defaultError}`,
          icon: 'error',
          confirmButtonColor: '#74a50a',
        }).then(() => {
          window.location.reload();
        });

        return;
      }

      Swal.fire({
        title: 'Atenção',
        text: `${error?.response?.data?.error || defaultError}`,
        icon: 'error',
        confirmButtonColor: '#74a50a',
      }).then(() => {
        window.location.reload();
      });
    }
  };

  return (
    <>
      <Helmet>
        <title>
          Recuperação de senha | SIHOSP - Sistema de Indicadores Hospitalares
        </title>
      </Helmet>
      <Breadcumbs path="recuperar-senha" pathTitle="Recuperação de senha" />
      <PageTitle>
        <span>Recuperação de senha</span>
      </PageTitle>
      <BoxAuth>
        <Left>
          <h4>
            Informe o <strong> CPF e E-mail</strong> cadastrados no sistema para
            recuperar sua senha.
          </h4>

          <form onSubmit={handleSubmit(onSubmit)}>
            <BoxLabel>
              <Label>CPF:</Label>
              <span
                className="notice"
                style={{ color: authError || cpfError ? '#cc0000' : null }}
              >
                *Preenchimento obrigatório
              </span>
            </BoxLabel>

            <input
              name="cpf"
              ref={register({
                pattern: /^\d{11}$/,
                min: 11,
                max: 11,
              })}
              id="cpf"
              style={{ borderColor: authError || cpfError ? '#cc0000' : null }}
            />

            {errors.cpf ? (
              <span>CPF é obritagório e deve ter 11 caracteres.</span>
            ) : (
              <span className="noticeInfo">
                (Somente os números, sem pontos)
              </span>
            )}

            <BoxLabel>
              <Label>E-mail:</Label>
              <span
                className="notice"
                style={{ color: authError || emailError ? '#cc0000' : null }}
              >
                *Preenchimento obrigatório
              </span>
            </BoxLabel>

            <input
              name="email"
              type="email"
              ref={register({})}
              style={{
                borderColor: authError || emailError ? '#cc0000' : null,
              }}
            />

            {errors.password ? (
              <span>O e-mail é obrigatório.</span>
            ) : (
              <span className="noticeInfo">E-mail cadastrado no sistema.</span>
            )}

            <div className="ButtonBox">
              <button type="submit">
                {loading ? 'Enviando...' : 'Enviar'}
              </button>
              <Link to="/">
                <MdArrowBack size={15} /> Voltar para a tela de login
              </Link>
            </div>
          </form>
        </Left>
      </BoxAuth>
    </>
  );
}
